import { WsBaseRequest } from 'api/ws/WsRequest';
import { API_METHOD_AUTH_TEST } from 'api/notificationManager/methods';

export default class AuthRequestTest extends WsBaseRequest {
  constructor() {
    super(API_METHOD_AUTH_TEST, {});
  }
}
